<template>
  <el-row type="flex" justify="center">底部</el-row>
</template>

<style >

</style>
<script>
export default {
    name: 'Footer',
};
</script>



// WEBPACK FOOTER //
// src/components/commonModel/footer.vue